import Http from "./http";

export const addProductFeaturesAPI = (data) => {
  return Http.post("admin/product/addProductFeature",data);
};
